// extracted by mini-css-extract-plugin
module.exports = {"flag":"ListItem_flag__5JML9","listItem":"ListItem_listItem__1VvgI"};